module.exports = __webpack_public_path__ + "img/syl_gallery11.73b04b98.jpg";